




























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { UpdateActivityCategoryRequest, ActivityCategoryDto } from '@/models/Activities';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'ActivityCategoryEdit'
})
export default class extends GiganautVueDialog {

  public entity = new ActivityCategoryDto();

  colorOptions = [
    { text: 'Blue', value: '#2196F3' },
    { text: 'Green', value: '#4CAF50' },
    { text: 'Orange', value: '#FF9800' },
    { text: 'Red', value: '#F44336' },
    { text: 'Purple', value: '#9C27B0' },
    { text: 'Teal', value: '#009688' },
    { text: 'Pink', value: '#E91E63' },
    { text: 'Indigo', value: '#3F51B5' },
    { text: 'Grey', value: '#9E9E9E' }
  ];

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      const category = JSON.parse(JSON.stringify(AgencySettingsModule.currentActivityCategory));
      this.entity.updatedAt = category.updatedAt;
      this.entity.name = category.name;
      this.entity.description = category.description;
      this.entity.color = category.color || '#2196F3';
      this.entity.isActive = category.isActive;
      this.entity.sortOrder = category.sortOrder;
      // Worker
      this.entity.isEnabledOnWorkerTask = category.isEnabledOnWorkerTask;
      this.entity.isEnabledOnWorkerNote = category.isEnabledOnWorkerNote;
      this.entity.isEnabledOnWorkerCall = category.isEnabledOnWorkerCall;
      this.entity.isEnabledOnWorkerMeeting = category.isEnabledOnWorkerMeeting;
      this.entity.isEnabledOnWorkerEmail = category.isEnabledOnWorkerEmail;
      // Company
      this.entity.isEnabledOnCompanyTask = category.isEnabledOnCompanyTask;
      this.entity.isEnabledOnCompanyNote = category.isEnabledOnCompanyNote;
      this.entity.isEnabledOnCompanyCall = category.isEnabledOnCompanyCall;
      this.entity.isEnabledOnCompanyMeeting = category.isEnabledOnCompanyMeeting;
      this.entity.isEnabledOnCompanyEmail = category.isEnabledOnCompanyEmail;
      // Location
      this.entity.isEnabledOnLocationTask = category.isEnabledOnLocationTask;
      this.entity.isEnabledOnLocationNote = category.isEnabledOnLocationNote;
      this.entity.isEnabledOnLocationCall = category.isEnabledOnLocationCall;
      this.entity.isEnabledOnLocationMeeting = category.isEnabledOnLocationMeeting;
      this.entity.isEnabledOnLocationEmail = category.isEnabledOnLocationEmail;
      // Contact
      this.entity.isEnabledOnContactTask = category.isEnabledOnContactTask;
      this.entity.isEnabledOnContactNote = category.isEnabledOnContactNote;
      this.entity.isEnabledOnContactCall = category.isEnabledOnContactCall;
      this.entity.isEnabledOnContactMeeting = category.isEnabledOnContactMeeting;
      this.entity.isEnabledOnContactEmail = category.isEnabledOnContactEmail;
      // Job
      this.entity.isEnabledOnJobTask = category.isEnabledOnJobTask;
      this.entity.isEnabledOnJobNote = category.isEnabledOnJobNote;
      this.entity.isEnabledOnJobCall = category.isEnabledOnJobCall;
      this.entity.isEnabledOnJobMeeting = category.isEnabledOnJobMeeting;
      this.entity.isEnabledOnJobEmail = category.isEnabledOnJobEmail;
      // Booking
      this.entity.isEnabledOnBookingTask = category.isEnabledOnBookingTask;
      this.entity.isEnabledOnBookingNote = category.isEnabledOnBookingNote;
      this.entity.isEnabledOnBookingCall = category.isEnabledOnBookingCall;
      this.entity.isEnabledOnBookingMeeting = category.isEnabledOnBookingMeeting;
      this.entity.isEnabledOnBookingEmail = category.isEnabledOnBookingEmail;
      // Campaign
      this.entity.isEnabledOnCampaignTask = category.isEnabledOnCampaignTask;
      this.entity.isEnabledOnCampaignNote = category.isEnabledOnCampaignNote;
      this.entity.isEnabledOnCampaignCall = category.isEnabledOnCampaignCall;
      this.entity.isEnabledOnCampaignMeeting = category.isEnabledOnCampaignMeeting;
      this.entity.isEnabledOnCampaignEmail = category.isEnabledOnCampaignEmail;
      // Opportunity
      this.entity.isEnabledOnOpportunityTask = category.isEnabledOnOpportunityTask;
      this.entity.isEnabledOnOpportunityNote = category.isEnabledOnOpportunityNote;
      this.entity.isEnabledOnOpportunityCall = category.isEnabledOnOpportunityCall;
      this.entity.isEnabledOnOpportunityMeeting = category.isEnabledOnOpportunityMeeting;
      this.entity.isEnabledOnOpportunityEmail = category.isEnabledOnOpportunityEmail;
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateActivityCategoryRequest();
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.description = this.entity.description;
    request.color = this.entity.color;
    request.isActive = this.entity.isActive;
    request.sortOrder = this.entity.sortOrder;
    // Worker
    request.isEnabledOnWorkerTask = this.entity.isEnabledOnWorkerTask;
    request.isEnabledOnWorkerNote = this.entity.isEnabledOnWorkerNote;
    request.isEnabledOnWorkerCall = this.entity.isEnabledOnWorkerCall;
    request.isEnabledOnWorkerMeeting = this.entity.isEnabledOnWorkerMeeting;
    request.isEnabledOnWorkerEmail = this.entity.isEnabledOnWorkerEmail;
    // Company
    request.isEnabledOnCompanyTask = this.entity.isEnabledOnCompanyTask;
    request.isEnabledOnCompanyNote = this.entity.isEnabledOnCompanyNote;
    request.isEnabledOnCompanyCall = this.entity.isEnabledOnCompanyCall;
    request.isEnabledOnCompanyMeeting = this.entity.isEnabledOnCompanyMeeting;
    request.isEnabledOnCompanyEmail = this.entity.isEnabledOnCompanyEmail;
    // Location
    request.isEnabledOnLocationTask = this.entity.isEnabledOnLocationTask;
    request.isEnabledOnLocationNote = this.entity.isEnabledOnLocationNote;
    request.isEnabledOnLocationCall = this.entity.isEnabledOnLocationCall;
    request.isEnabledOnLocationMeeting = this.entity.isEnabledOnLocationMeeting;
    request.isEnabledOnLocationEmail = this.entity.isEnabledOnLocationEmail;
    // Contact
    request.isEnabledOnContactTask = this.entity.isEnabledOnContactTask;
    request.isEnabledOnContactNote = this.entity.isEnabledOnContactNote;
    request.isEnabledOnContactCall = this.entity.isEnabledOnContactCall;
    request.isEnabledOnContactMeeting = this.entity.isEnabledOnContactMeeting;
    request.isEnabledOnContactEmail = this.entity.isEnabledOnContactEmail;
    // Job
    request.isEnabledOnJobTask = this.entity.isEnabledOnJobTask;
    request.isEnabledOnJobNote = this.entity.isEnabledOnJobNote;
    request.isEnabledOnJobCall = this.entity.isEnabledOnJobCall;
    request.isEnabledOnJobMeeting = this.entity.isEnabledOnJobMeeting;
    request.isEnabledOnJobEmail = this.entity.isEnabledOnJobEmail;
    // Booking
    request.isEnabledOnBookingTask = this.entity.isEnabledOnBookingTask;
    request.isEnabledOnBookingNote = this.entity.isEnabledOnBookingNote;
    request.isEnabledOnBookingCall = this.entity.isEnabledOnBookingCall;
    request.isEnabledOnBookingMeeting = this.entity.isEnabledOnBookingMeeting;
    request.isEnabledOnBookingEmail = this.entity.isEnabledOnBookingEmail;
    // Campaign
    request.isEnabledOnCampaignTask = this.entity.isEnabledOnCampaignTask;
    request.isEnabledOnCampaignNote = this.entity.isEnabledOnCampaignNote;
    request.isEnabledOnCampaignCall = this.entity.isEnabledOnCampaignCall;
    request.isEnabledOnCampaignMeeting = this.entity.isEnabledOnCampaignMeeting;
    request.isEnabledOnCampaignEmail = this.entity.isEnabledOnCampaignEmail;
    // Opportunity
    request.isEnabledOnOpportunityTask = this.entity.isEnabledOnOpportunityTask;
    request.isEnabledOnOpportunityNote = this.entity.isEnabledOnOpportunityNote;
    request.isEnabledOnOpportunityCall = this.entity.isEnabledOnOpportunityCall;
    request.isEnabledOnOpportunityMeeting = this.entity.isEnabledOnOpportunityMeeting;
    request.isEnabledOnOpportunityEmail = this.entity.isEnabledOnOpportunityEmail;

    await AgencySettingsModule.editActivityCategory(request);
    this.dialog = false;
  }
}
